import { useEffect } from 'react';
import { usePostHog } from 'posthog-js/react';
import { useLocation } from 'react-router-dom';

export default function PostHogPageView() {
    let location = useLocation();
    const posthog = usePostHog();
    // Track pageviews
    useEffect(() => {
        if (posthog) {
            posthog.capture('$pageview', {
                $current_url: window.location.href,
            });
        }
    }, [location]);

    return null;
}
